/**
 * PDF da cotação — SERVER-SIDE (pdfkit no backend).
 *
 * `GET /api/v1/quote/:id/pdf` retorna o PDF binário. Buscamos como **blob** pelo
 * cliente `api` (que injeta `Authorization: Bearer` — um <a href> direto não
 * levaria o token). Duas ações: baixar (download) e visualizar (abre numa aba).
 */
import api from "../Services/api";

const fetchPdf = (quoteId, { inline = false } = {}) =>
	api.get(`/api/v1/quote/${quoteId}/pdf`, {
		responseType: "blob",
		params: inline ? { inline: 1 } : undefined,
	});

const filenameFrom = (res, quoteId) => {
	const cd = res.headers?.["content-disposition"] || "";
	const match = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(cd);
	if (match && match[1]) {
		try { return decodeURIComponent(match[1]); } catch (e) { return match[1]; }
	}
	return `cotacao-${quoteId}.pdf`;
};

/** Baixa o PDF da cotação (download). */
export const printQuote = async (quote) => {
	if (!quote || !quote.id) return;
	const res = await fetchPdf(quote.id);
	const url = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
	const a = document.createElement("a");
	a.href = url;
	a.download = filenameFrom(res, quote.id);
	document.body.appendChild(a);
	a.click();
	a.remove();
	setTimeout(() => URL.revokeObjectURL(url), 1500);
};

/**
 * Busca o PDF e retorna um **blob URL** (object URL) p/ exibir num iframe/modal.
 * O chamador é responsável por `URL.revokeObjectURL` ao fechar.
 */
export const fetchQuotePdfUrl = async (quote) => {
	if (!quote || !quote.id) return null;
	const res = await fetchPdf(quote.id, { inline: true });
	return URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
};

/** Abre o PDF da cotação numa nova aba (visualizar sem baixar). */
export const viewQuotePdf = async (quote) => {
	if (!quote || !quote.id) return;
	// Abre a aba JÁ no clique (evita bloqueio de popup após o await).
	const win = window.open("", "_blank");
	try {
		const res = await fetchPdf(quote.id, { inline: true });
		const url = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
		if (win && !win.closed) {
			win.location.href = url;
		} else {
			// Popup bloqueado → baixa como fallback.
			const a = document.createElement("a");
			a.href = url;
			a.download = filenameFrom(res, quote.id);
			document.body.appendChild(a);
			a.click();
			a.remove();
		}
		// A aba precisa do blob vivo p/ renderizar — revoga depois de um tempo.
		setTimeout(() => URL.revokeObjectURL(url), 60000);
	} catch (e) {
		if (win && !win.closed) win.close();
		throw e;
	}
};

export default printQuote;
